import React from 'react'

import BlockContent from "@sanity/block-content-to-react";

const InfoSection = ({title, body, image, year, tag, projectType, website}) => {
  return (
    <div className=' mx-auto flex p-4 lg:px-8 text-white mt-8 overflow-x-hidden'>
<div class="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8 w-full">
<div class=" rounded-lg ">
    <h1 className=' project-title-info mb-7'>{title}</h1>
    <span className=' text-gray-400 font-normal text-4xl mb-7 '>{tag}</span>
   <div className=" flex items-center mt-7">
    <a href={website} target="_blank" rel="noopener noreferrer"  className="px-3 py-2 bg-white text-black rounded-full font-extralight text-sm uppercase mr-3 title-p">{projectType}</a>
    {/* <div className="px-5 py-2  border-gray-400 border-[0.2px] text-white rounded-full font-extralight text-base uppercase title-p">{year}</div> */}

   </div>

  <div className=" mt-52">
    <span className=' title-p  text-white '>About</span>
    <div className=' text-[#A3A3A3] text-base font-normal uppercase title-p mt-4 mb-6 '>
    <BlockContent
    className={''}
          blocks={body}
        //   projectId={client.clientConfig.projectId}
        //   dataset={client.clientConfig.dataset}
        />
    </div>
    {/* <a href={website} target="_blank" rel="noopener noreferrer" className=' title-p text-white font-bold border-b-4'>
        <p className=' hover:animate-bounce '>Visit</p>
        <hr  className=' w-12 mt-2  hover:animate-bounce'/>
    </a> */}
  </div>
</div>
  <div class="   rounded-[2.4rem] bg-gray-700 lg:col-span-2 md:h-screen"
  
  style={{
    backgroundImage: ` url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top',
  }}>
  </div>

  <img src={image} alt="" className=' md:hidden rounded-3xl' />
  
</div>
        </div>
  )
}

export default InfoSection